import { render, staticRenderFns } from "./TeamReports.vue?vue&type=template&id=c40080b6&"
import script from "./TeamReports.vue?vue&type=script&lang=js&"
export * from "./TeamReports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c40080b6')) {
      api.createRecord('c40080b6', component.options)
    } else {
      api.reload('c40080b6', component.options)
    }
    module.hot.accept("./TeamReports.vue?vue&type=template&id=c40080b6&", function () {
      api.rerender('c40080b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/settings/reports/TeamReports.vue"
export default component.exports